<template>
	<GoalSubHeaderLayout class="goal-sub-header-skeleton">
		<template #team-name>
			<Skeleton />
			<div class="skeleton-value">
				<Skeleton />
			</div>
		</template>
		<template #due-date>
			<Skeleton />
			<div class="skeleton-value">
				<Skeleton />
			</div>
		</template>
		<template #last-updated>
			<Skeleton />
			<div class="skeleton-value">
				<Skeleton />
			</div>
		</template>
		<template #confidence-level>
			<Skeleton />
			<div class="skeleton-value">
				<Skeleton />
			</div>
		</template>
		<template #progress>
			<Skeleton />
			<div class="skeleton-value">
				<Skeleton />
			</div>
		</template>
	</GoalSubHeaderLayout>
</template>

<script>
import Skeleton from "primevue/skeleton";
import GoalSubHeaderLayout from "./GoalSubHeaderLayout";

export default {
	name: "GoalSubHeaderSkeleton",
	components: {
		GoalSubHeaderLayout,
		Skeleton,
	},
};
</script>

<style lang="scss" scoped>
.skeleton-value {
	width: 50%;
}
</style>

<style lang="scss">
.goal-sub-header-skeleton {
	.goal-sub-header-layout__stack {
		flex: 1;
	}
}
</style>
